"use client";

import React from "react";
import { ArrowRight, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MetabolicAssessmentCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="metabolicassessmentcta" data-nav="light" ref={ref} className="relative bg-background text-foreground py-20 md:py-28 overflow-hidden isolate">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }} className="transition-all duration-700 ease-out relative rounded-2xl border border-border bg-card text-card-foreground p-8 sm:p-12 md:p-16 shadow-md text-center">
          {/* Subtle background glow effect using tokens */}
          <div aria-hidden="true" className="absolute inset-0 pointer-events-none -z-10 rounded-2xl bg-[radial-gradient(ellipse_at_top,var(--primary)/0.08,transparent_70%)]" />

          <div className="max-w-3xl mx-auto space-y-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-default font-bold tracking-tight text-foreground text-balance">
              Stop guessing. Measure how your body responds.
            </h2>

            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed text-balance">
              {"Choose VO₂ Max, Resting Metabolic Rate, or combine both for PhysAnalytica's most complete metabolic assessment."}
            </p>

            {/* Pricing Summary Line */}
            <div className="inline-flex items-center justify-center rounded-full bg-secondary/80 px-4 py-2 text-xs sm:text-sm font-medium text-secondary-foreground border border-border shadow-xs">
              <span>RMR £90 · VO₂ Max £160 · Complete Assessment £220</span>
            </div>

            {/* Action Buttons */}
            <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto">
                <Link to="#" className="inline-flex items-center gap-2">
                  <span>Book or Enquire</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
                <Link to="#" className="inline-flex items-center gap-2">
                  <Mail className="size-4" />
                  <span>Contact PhysAnalytica</span>
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}